export const tokens = {
    list: {
        rows: 4,
        gap: 10,
    },
    emoji: {
        // This value is currently an approximation that gets us
        // comfortably within 7 columns. There should be a better
        // way to compute this value.
        size: 26,
    },
};
